// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_hi-0";
export var optionCard = "_hi-1";